// numberFormatR.js
// numberFormat 과 반대로 숫자중 콤마를 제거한다.
export default (value = '') => {
  return String(value).replace(/(\d{1,3}),?/g, '$1')
}
